export const site = {
  name: '导航爆料',
  slogan: '吃瓜高效，分类不迷路',
  desc: '把散落各处的热点与话题，按「话题 / 事件 / 人物 / 机构」分门别类，让你想追哪个瓜，就直接进哪一栏。',
  email: 'hello@daohangbaoliao.example.com',
};

export interface HotTag {
  name: string;
  cat: string;
  heat: string;
}

export const hotTags: HotTag[] = [
  { name: '信息断舍离', cat: 'huati', heat: '128.4万' },
  { name: '慢直播回归', cat: 'huati', heat: '96.7万' },
  { name: '笔记App登顶', cat: 'shijian', heat: '82.1万' },
  { name: '凌晨三点的热搜', cat: 'shijian', heat: '79.5万' },
  { name: '内容策展人', cat: 'renwu', heat: '64.3万' },
  { name: '订阅制出版社', cat: 'jigou', heat: '57.9万' },
  { name: '平台辟谣治理', cat: 'jigou', heat: '49.2万' },
  { name: '古籍播客实验', cat: 'renwu', heat: '41.6万' },
];

export interface Review {
  text: string;
  name: string;
  role: string;
}

export const reviews: Review[] = [
  { text: '以前刷半天信息流都找不到想看的瓜，现在按分类点进去一目了然，效率高多了。', name: '林同学', role: '考研党' },
  { text: '事件类的梳理做得挺克制，把时间线讲清楚，不煽动情绪，这点很难得。', name: '周编辑', role: '自媒体人' },
  { text: '会把「机构动向」单独列出来，对我判断行业风向很有帮助，算是少数不浮躁的浏览站。', name: '许先生', role: '产品经理' },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '导航爆料的内容是如何分类的？',
    a: '我们把站内内容按「热门话题、热点事件、人物动态、机构观察」四大类整理。话题偏讨论与趋势，事件还原始末，人物关注行业面孔，机构追踪品牌平台动向。每条内容都挂有标签，方便你二次筛选。',
  },
  {
    q: '可以订阅或收藏感兴趣的话题吗？',
    a: '目前支持通过顶部搜索按标题与标签定位内容，也可以直接进入对应分类页持续浏览。收藏与通知功能正在规划中，后续会逐步上线。',
  },
  {
    q: '内容中的热度与数据从哪里来？',
    a: '阅读数、评论数与热度均基于站内浏览行为估算，用于展示内容受欢迎程度，不代表第三方平台数据。我们会在涉及外部数据时标注来源。',
  },
  {
    q: '平台如何保证信息的真实性？',
    a: '我们坚持对存疑内容做多方交叉核实，事件类会梳理时间线并提示信源。涉及争议话题时，会尽量并列呈现不同观点，避免只推送单一声量。',
  },
  {
    q: '我发现了错误信息，可以反馈吗？',
    a: '非常欢迎。你可以在站内文章页通过「纠错」入口或直接邮件联系我们，我们核实后会尽快修正，并在显著位置更新。',
  },
];